import {
  aboutUs,
  backmarketWarranty,
  boMerchant,
  buyingGuides,
  cookiePolicy,
  dataProtection,
  help,
  hireExternal,
  infosConsumer,
  legal,
  medium,
  modelsComparison,
  studentGoodDeals,
  termsSale,
  termsUse,
} from './shared-links'
import type { FooterConfig } from './types'

export const ptConfig: FooterConfig = {
  columns: [
    {
      titleKey: 'categoryAbout',
      links: [aboutUs, studentGoodDeals, hireExternal],
      socials: [
        {
          name: 'instagram',
          href: 'https://www.instagram.com/backmarket_pt',
        },
        {
          name: 'linkedin',
          href: 'https://www.linkedin.com/company/back-market',
        },
        {
          name: 'facebook',
          href: 'https://www.facebook.com/backmarket.es',
        },
      ],
    },
    {
      titleKey: 'categoryHelp',
      links: [
        {
          translationKey: 'becomeRefurbisher',
          href: 'https://backmarket.pt/pt-pt/seller/home',
        },
        boMerchant,
        {
          translationKey: 'payment',
          href: 'https://help.backmarket.com/hc/pt/articles/360026643854',
        },
        {
          translationKey: 'shipping',
          href: 'https://help.backmarket.com/hc/pt/articles/360026646054',
        },
        {
          translationKey: 'return',
          href: 'https://help.backmarket.com/hc/pt/categories/360002106194-Devolu%C3%A7%C3%B5es-Reembolsos-Returns-refunds-R%C3%BCckgabe-R%C3%BCckerstattung-Returns-refunds',
        },
        help,
        buyingGuides,
        modelsComparison,
      ],
    },
    {
      titleKey: 'categoryLaw',
      links: [
        termsUse,
        termsSale,
        backmarketWarranty,
        dataProtection,
        cookiePolicy,
        infosConsumer,
        legal,
        {
          translationKey: 'illegalContent',
          href: 'https://help.backmarket.com/hc/pt/requests/new?ticket_form_id=12226993197084',
        },
      ],
      payment: { translationKey: 'paymentMethods' },
    },
    {
      titleKey: 'categoryHello',
      links: [
        {
          translationKey: 'trustpilot',
          href: 'https://pt.trustpilot.com/review/backmarket.pt?languages=all',
        },
        medium,
      ],
    },
    {
      logos: ['bcorp'],
    },
  ],
}
